import { Component, OnInit, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { RegistroService } from 'src/app/registro/registro.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-modal-registro-jucesp',
  templateUrl: './modal-registro-jucesp.component.html',
  styleUrls: ['./modal-registro-jucesp.component.scss']
})
export class ModalRegistroJucespComponent implements OnInit {

  orgaoDeferimento: any;
  mensagemExibir: any;
  linkExibir: string;
  eventoQtd: any;
  idEvento: any;
  dadosCarregados: boolean;
  errorDados: boolean;
  protocoloDigitado: any;
  loginAuth: string;

  @ViewChild('pesquisaProtocolo') pesquisaProtocolo:ElementRef;

  constructor(
    private modalService: NgbModal,
    public activeModal: NgbActiveModal,
    private registroService: RegistroService
  ) { }

  idNaturezaJuridica: any;
  descNaturezaJuridica: any;

  ngAfterViewInit() {
    setTimeout(() => this.pesquisaProtocolo.nativeElement.focus());
  }   

  ngOnInit() {
    this.dadosCarregados = false;
    this.errorDados = false;

    this.loginAuth = sessionStorage.getItem('loginAuth');
  }

  pesquisarProtocolo() {
    this.registroService.orgaoRegistroPesquisa(this.protocoloDigitado.toUpperCase())
      .then((data) => {
        this.idNaturezaJuridica = data.dadosRedesim.fcpj.codNaturezaJuridica;
        this.orgaoDeferimento = data.dadosRedesim.orgaoResponsavelDeferimento;
        this.eventoQtd = data.dadosRedesim.fcpj.codEvento.length;
        for (let i = 0; i < data.dadosRedesim.fcpj.codEvento.length; i++) {
          this.idEvento = data.dadosRedesim.fcpj.codEvento[i];
        }
        this.defineOrgao(this.orgaoDeferimento);
        this.dadosCarregados = true;
        this.errorDados = false;
      })
      .catch(error => {
        this.dadosCarregados = false;
        this.errorDados = true;
      });
  }

  defineOrgao(orgaoDeferimento) { 
    if (orgaoDeferimento == 'JCSP') { 

      if (this.eventoQtd == 1 && this.idEvento == 101 && (this.idNaturezaJuridica == 2062 || this.idNaturezaJuridica == 2135 || this.idNaturezaJuridica == 2305 )) {
        this.mensagemExibir = `Esse protocolo de referência ${this.protocoloDigitado} é de responsabilidade de deferimento por parte da JUCESP - Junta Comercial de São Paulo. Para iniciar o processo acesse o sistema VRE | Digital clicando`;
        this.linkExibir = environment.linkRegistro + this.loginAuth;
      } else {
        this.mensagemExibir = `Esse protocolo de referência ${this.protocoloDigitado} é de responsabilidade de deferimento por parte da JUCESP - Junta Comercial de São Paulo. Para iniciar o processo acesse o sistema VRE clicando`;
        this.linkExibir = environment.linkVRE + this.loginAuth;
      }

    } 
  }


  limpaCampos() {    
    this.mensagemExibir = false;
    this.dadosCarregados = false;
    this.errorDados = false;
    this.protocoloDigitado = '';
    this.dadosCarregados = false;
    this.pesquisaProtocolo.nativeElement.value = '';
    this.pesquisaProtocolo.nativeElement.focus();
  }  

}
